import { render, staticRenderFns } from "./OwnerList.vue?vue&type=template&id=9bc81c10&scoped=true&"
import script from "./OwnerList.vue?vue&type=script&lang=js&"
export * from "./OwnerList.vue?vue&type=script&lang=js&"
import style0 from "./OwnerList.vue?vue&type=style&index=0&id=9bc81c10&prod&lang=scss&scoped=true&"
import style1 from "./OwnerList.vue?vue&type=style&index=1&id=9bc81c10&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bc81c10",
  null
  
)

export default component.exports